import Authenticatable from "./authenticatable";
import ToolbarActionable from "./toolbar-actionable";

export default {
	name: "KioskableMixin",

	mixins: [
		Authenticatable,
		ToolbarActionable
	],

	props: { kiosk: Boolean },

	data: () => ( {
		kioskRoute: null
	} ),

	computed: {
		toolbarActions() {
			if ( !this.kiosk && this.kioskRoute ) {
				return {
					icon: "fullscreen",
					text: "Kiosk Mode",
					to: this.kioskRoute,
					tooltip: "View in kiosk mode"
				};
			}
		}
	},

	watch: {
		kiosk: {
			handler( val ) {
				this.$store.dispatch( "kiosk/set", val );
			},
			immediate: true
		}
	},

	destroyed() {
		this.$store.dispatch( "kiosk/set", false );
	}
};
